<template>
    <div style="padding: 20px 0">
        <center>
            <el-radio-group v-model="chartMode" @change="updateChart">
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="deposit">存款</el-radio-button>
                <el-radio-button label="loan">借款</el-radio-button>
            </el-radio-group>
        </center>
        <div v-loading="isLoading" element-loading-text="載入中" style="min-height: 280px">
            <v-chart
                :option="monthlyChartData"
                ref="mainChart"
                style="
                    width: 90%;
                    height: 330px;
                    margin-top: 25px;
                    margin-bottom: 20px;
                    margin-left: auto;
                    margin-right: auto;
                "
            />
        </div>
    </div>
</template>
<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent, ToolboxComponent]);

export default {
    components: {
        VChart,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        isRemoveEmpty: {
            type: Boolean,
            default: true,
        },
        data: {
            type: Array,
            default: () => ({}),
        },
        year: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        data(newValue) {
            if (newValue !== null) {
                console.log('newvalue', newValue);
                this.updateChart();
            }
        },
    },
    data() {
        return {
            chartMode: 'all', // all, deposit, loan

            // 銀行每月存量圖
            monthlyChartData: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985',
                        },
                    },
                },
                backgroundColor: 'transparent',
                legend: {
                    data: [],
                },
                toolbox: {},
                grid: {
                    top: '50px',
                    left: '30px',
                    right: '30px',
                    bottom: '30px',
                    containLabel: true,
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                    },
                ],
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                },
                series: [],
            },

            // 存借款比較直條圖
            compareChartData: {
                backgroundColor: 'transparent',
                grid: {
                    top: '90px',
                    bottom: '30px',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: ['存款總額', '借款總額'],
                },
                yAxis: {
                    type: 'value',
                },
                series: [
                    {
                        data: [
                            {
                                value: 0,
                                itemStyle: {
                                    color: '#00cc00',
                                },
                            },
                            {
                                value: 0,
                                itemStyle: {
                                    color: '#ff9d00',
                                },
                            },
                        ],
                        type: 'bar',
                    },
                ],
            },
        };
    },
    mounted() {
        window.addEventListener('resize', this.updateChartSize);
    },
    destroyed() {
        window.removeEventListener('resize', this.updateChartSize);
    },
    methods: {
        updateChartSize() {
            this.$refs.mainChart.resize();
        },
        updateChart() {
            const bankNames = [];
            const bankMonthlyData = [];
            const monthlySum = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            const monthlyDepositSum = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            const monthlyLoanSum = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

            // 各銀行帳戶
            for (var i = 0; i < this.data.length; i++) {
                const bank = this.data[i];

                // 僅存款
                if (this.chartMode === 'deposit') {
                    if (bank.isBorrower) continue;
                }
                // 僅借款
                else if (this.chartMode === 'loan') {
                    if (!bank.isBorrower) continue;
                }

                // 名稱 (null = 零用金)
                const bankName = bank.bnK_NAM === null ? '零用金' : bank.bnK_NAM;
                bankNames.push(bankName);

                // 1~12月資料
                const monthlyData = [];
                let isEmpty = true;
                for (let j = 0; j < bank.monthlyBankBalanceInfos.length; j++) {
                    const bal = Math.round(bank.monthlyBankBalanceInfos[j].bal);

                    // 個別銀行餘額
                    monthlyData.push(bal);

                    // 加總餘額（for 合併總計)
                    monthlySum[j] += bal;

                    // 加總餘額（for sumup)
                    if (!bank.isBorrower) monthlyDepositSum[j] += bal;
                    if (bank.isBorrower) monthlyLoanSum[j] += bal;

                    if (bal !== 0) isEmpty = false;
                }

                // 移除全年都為零的帳戶（isRemoveEmpty)
                if (this.isRemoveEmpty && isEmpty) continue;

                bankMonthlyData.push({
                    name: bankName,
                    type: 'line',
                    smooth: false,
                    data: monthlyData,
                });
            }

            // 合併總計
            bankNames.unshift('合併總計');
            bankMonthlyData.unshift({
                name: '合併總計',
                type: 'line',
                data: monthlySum,
                itemStyle: {
                    normal: {
                        color: '#ffffff',
                    },
                },
            });

            // 去除今年未到月份
            if (this.year == new Date().getFullYear()) {
                const currMonth = new Date().getMonth();
                for (let s = 0; s < bankMonthlyData.length; s++) {
                    for (i = 0; i < bankMonthlyData[s].data.length; i++) {
                        if (i > currMonth && bankMonthlyData[s].data[i] == 0) {
                            bankMonthlyData[s].data[i] = null;
                        }
                    }
                }
            }

            // 重載圖表
            const newChartData = JSON.parse(JSON.stringify(this.monthlyChartData));
            newChartData.legend.data = bankNames;
            newChartData.series = bankMonthlyData;

            if (bankNames.length <= 10) {
                newChartData.grid.top = '70px';
            }
            if (bankNames.length > 10) {
                newChartData.grid.top = '90px';
            }

            this.$refs.mainChart.clear();
            this.monthlyChartData = newChartData;
        },
    },
};
</script>
